module.exports = __webpack_public_path__ + "img/icon-ai.24ab011d.svg";